import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraButton, SpecraInlineBanner } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useBundleVersionCheck } from '../hooks/useBundleVersionCheck';
export const STALE_BUNDLE_COPY = 'A new version of Specra is available. Reload to update';
/**
 * Non-blocking notice when dock-one is serving a newer bundle than this tab.
 * Reload is always a click — never automatic, including while the user is
 * typing, has an unsent draft, or has a dialog open.
 */ export function StaleBundleNotice({ onReload }) {
    const { updateAvailable } = useBundleVersionCheck();
    if (!updateAvailable) {
        return null;
    }
    // The app shell is `fixed inset-0`, so an in-flow banner sits underneath it:
    // present in the DOM, invisible and unclickable. Float it above the shell.
    return /*#__PURE__*/ _jsx("div", {
        className: "pointer-events-none fixed inset-x-0 bottom-4 z-50 flex justify-center px-4",
        children: /*#__PURE__*/ _jsx("div", {
            className: "pointer-events-auto overflow-hidden rounded-lg border border-border shadow-lg",
            children: /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                action: /*#__PURE__*/ _jsx(SpecraButton, {
                    "data-testid": Testids.assistant.staleBundleReload,
                    onClick: ()=>(onReload ?? (()=>window.location.reload()))(),
                    size: "sm",
                    variant: "secondary",
                    children: "Reload"
                }),
                "data-testid": Testids.assistant.staleBundleBanner,
                tone: "info",
                children: STALE_BUNDLE_COPY
            })
        })
    });
}
